import * as fromMonitoreoActions from './monitoreo.actions';
import { initialState, MonitoreoState } from './monitoreo.model';
import { Action, createReducer, on } from '@ngrx/store';


const methodReducer = createReducer(
  initialState,

  // COM Hora actualización *******
  on(fromMonitoreoActions.addHoraActualizado, (state, { newHora }) => ({
    ...state,
    hora: newHora
  })),
  on(fromMonitoreoActions.removeHoraActualizado, (state) => ({
    ...state,
    hora: ''
  })),
  // COM Contador de apertura Movil filtro *******
  on(fromMonitoreoActions.addContador, (state, { newCounter }) => ({
    ...state,
    contador: newCounter
  })),
  on(fromMonitoreoActions.removeContador, (state) => ({
    ...state,
    contador: 0
  })),

);


// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export function reducer(state: MonitoreoState | undefined, action: Action): MonitoreoState {
  return methodReducer(state, action);
}






